module.exports = __webpack_public_path__ + "img/ro.4f9795be.png";